<div
   class="insights-shell"
   [class.panel-open]="pendingUserSelect != null || panelOpened">
   <div class="insights-topbar">
      <div class="brand">
         <div class="brand-title">Admin Console</div>
      </div>

      <input
         type="checkbox"
         id="mobileMenuToggle"
         class="menu-toggle" />

      <label
         for="mobileMenuToggle"
         class="menu-icon"></label>
      <div class="admin-tab-nav">
         <div
            class="admin-tab-item"
            [class.active]="activeTab === 'home'"
            (click)="setTab('home')">
            Dashboard
         </div>
         <div
            class="admin-tab-item"
            [class.active]="activeTab === 'ai'"
            style="position: relative"
            (click)="setTab('ai')">
            <i class="fa-solid fa-wand-magic-sparkles"></i>
            &nbsp;AI Insights
            <div class="new-link-tag">NEW!</div>
         </div>
         <div
            class="admin-tab-item"
            [class.active]="activeTab === 'analytics'"
            (click)="setTab('analytics')">
            Analytics
         </div>
         <div
            *ngIf="isReportingAdmin()"
            class="admin-tab-item"
            [class.active]="activeTab === 'cycles'"
            (click)="setTab('cycles')">
            Cycles
         </div>
         <div
            *ngIf="isReportingAdmin()"
            class="admin-tab-item"
            [class.active]="activeTab === 'users'"
            (click)="setTab('users')">
            Users
         </div>
         <div
            class="admin-tab-item"
            [class.active]="activeTab === 'exports' || activeTab === 'audit'"
            (click)="setTab('exports')">
            Data
         </div>
         <div
            *ngIf="isReportingAdmin()"
            class="settings-menu-wrap">
            <button
               type="button"
               class="admin-tab-item settings-tab-button"
               [class.active]="settingsOpen || settingsMenuOpen"
               (click)="toggleSettingsMenu($event)"
               title="Admin settings"
               aria-label="Admin settings"
               [attr.aria-expanded]="settingsMenuOpen">
               <i class="fa fa-gear"></i>
               <span
                  class="settings-attention-dot"
                  *ngIf="settingsMessageCount > 0"></span>
            </button>

            <div
               class="settings-menu-popover"
               *ngIf="settingsMenuOpen"
               (click)="$event.stopPropagation()">
               <div class="settings-menu-caret"></div>

               <div class="settings-menu-header">
                  <div class="settings-menu-title">Admin settings</div>
                  <div
                     class="settings-menu-subtitle"
                     style="font-style: italic">
                     Super admins only
                  </div>
               </div>

               <div class="settings-menu-divider"></div>

               <div class="settings-menu-section-label">Platform</div>

               <button
                  type="button"
                  class="settings-menu-option"
                  (click)="openSettings('roles')">
                  <span class="settings-menu-option-icon">
                     <i class="fa fa-shield-halved"></i>
                  </span>
                  <span class="settings-menu-option-copy">
                     <span class="settings-menu-option-title">Roles &amp; Permissions</span>
                     <span class="settings-menu-option-desc">Who can see and change what across the platform</span>
                  </span>
               </button>

               <button
                  type="button"
                  class="settings-menu-option"
                  (click)="openSettings('reminders')">
                  <span class="settings-menu-option-icon">
                     <i class="fa-regular fa-clock"></i>
                  </span>
                  <span class="settings-menu-option-copy">
                     <span class="settings-menu-option-title">Reminders</span>
                     <span class="settings-menu-option-desc">Automatic nudges sent to reviewers and reviewees</span>
                  </span>
               </button>

               <div class="settings-menu-section-label settings-menu-account-label">Your account</div>

               <button
                  type="button"
                  class="settings-menu-option"
                  (click)="openSettings('messages')">
                  <span class="settings-menu-option-icon">
                     <i class="fa-regular fa-comments"></i>
                  </span>
                  <span class="settings-menu-option-copy">
                     <span class="settings-menu-option-title">
                        Messages
                        <span
                           class="settings-menu-new-badge"
                           *ngIf="settingsMessageCount > 0">
                           {{ settingsMessageCount }} new
                        </span>
                     </span>
                     <span class="settings-menu-option-desc">Chats other users have looped you into</span>
                  </span>
               </button>
            </div>
         </div>
      </div>
   </div>

   <!-- HOME TAB -->
   <div *ngIf="activeTab === 'home'">
      <app-home-dashboard (navigateToDeferrals)="goToUserManagementDeferrals()"></app-home-dashboard>
   </div>

   <!-- AI INSIGHTS TAB -->
   <div *ngIf="activeTab === 'ai'">
      <app-ai-insights></app-ai-insights>
   </div>

   <!-- ANALYTICS TAB -->
   <div
      [class]="!allAnalyticsLoaded ? 'loading-analytics-tab' : ''"
      *ngIf="activeTab === 'analytics'">
      <span
         *ngIf="!allAnalyticsLoaded"
         class="spinnerSave"
         style="
            margin-left: auto;
            margin-right: auto;
            border-color: #ffffff;
            border-top: 2px solid transparent;
            margin-bottom: -13px;
            display: block;
         "></span>
      <div class="rt-row">
         <span style="font-size: 14px; font-weight: 500">Review Type:</span>
         <span
            class="reviewtype-select-pill"
            [class.on]="reviewType === 'DVM'"
            [class.off]="reviewType !== 'DVM'">
            <select
               [(ngModel)]="selectedDvmCycle"
               (change)="setDvmCycle(selectedDvmCycle)"
               aria-label="DVM review cycle">
               <option value="Q1">DVM (Q1)</option>
               <option value="Q2">DVM (Q2)</option>
               <option value="Q3">DVM (Q3)</option>
            </select>
         </span>
         <span
            class="reviewtype-pill"
            [class.on]="reviewType === 'HM'"
            [class.off]="reviewType !== 'HM'"
            (click)="setReviewType('HM')">
            HM
         </span>
         <span
            class="reviewtype-pill"
            [class.on]="reviewType === 'COS'"
            [class.off]="reviewType !== 'COS'"
            (click)="setReviewType('COS')">
            COS
         </span>
         <span
            class="reviewtype-pill"
            [class.on]="reviewType === 'RM'"
            [class.off]="reviewType !== 'RM'"
            (click)="setReviewType('RM')">
            RM
         </span>
         <span
            class="reviewtype-pill"
            [class.on]="reviewType === 'DO'"
            [class.off]="reviewType !== 'DO'"
            (click)="setReviewType('DO')">
            DO
         </span>
      </div>

      <div
         class="kpi-row"
         *ngIf="vm as v">
         <div class="kpi kpi-blue">
            <div class="kpi-title">Total Reviews Started</div>
            <div class="kpi-value">{{ v.totalReviews }}</div>
            <div class="kpi-sub">{{ getRevieweeLabel(true) }} Self-Assessments</div>
         </div>
         <div class="kpi kpi-yellow">
            <div class="kpi-title">{{ getRevieweeLabel(true) }} Submitted</div>
            <div class="kpi-value">{{ v.dvmSubmitted }}</div>
            <div class="kpi-sub">{{ v.totalReviews ? ((v.dvmSubmitted / v.totalReviews) * 100 | number: "1.0-0") : 0 }}%</div>
         </div>
         <div class="kpi kpi-orange">
            <div class="kpi-title">{{ getReviewerLabel(true) }} Submitted</div>
            <div class="kpi-value">{{ v.cosSubmitted }}</div>
            <div class="kpi-sub">{{ v.totalReviews ? ((v.cosSubmitted / v.totalReviews) * 100 | number: "1.0-0") : 0 }}%</div>
         </div>
         <div class="kpi kpi-purple">
            <div class="kpi-title">Total Reviews Completed</div>
            <div class="kpi-value">{{ v.revCompleted }}</div>
            <div class="kpi-sub">{{ v.totalReviews ? ((v.revCompleted / v.totalReviews) * 100 | number: "1.0-0") : 0 }}%</div>
         </div>
      </div>

      <div
         class="main-grid"
         *ngIf="vm as v">
         <div class="left">
            <div class="q-card">
               <div class="panel-title">Question Insights</div>
               <ng-container *ngFor="let group of groupedQuestionCards">
                  <div class="q-inner-card">
                     <div class="q-head">
                        <div class="q-title">
                           {{ group.title }}
                           <span class="rep-badge badge-scale">Merged View</span>
                        </div>
                        <div class="q-score">
                           <div class="q-score-val">{{ group.avgAgreement }}</div>
                           <div class="q-score-sub">Agreement score</div>
                        </div>
                     </div>
                     <div
                        *ngFor="let card of group.cards"
                        class="q-group-item">
                        <div class="subtitle">
                           {{ card.subtitle }}
                        </div>
                        <div class="q-body">
                           <div class="dist">
                              <div class="dist-title">
                                 <span class="dot dot-blue"></span>
                                 {{ getRevieweeLabel(true) }} DISTRIBUTION
                              </div>
                              <div class="rev-rows">
                                 <div
                                    *ngFor="let r of card.revieweeDistribution"
                                    class="rev-row">
                                    <div class="rev-row-label">{{ r.label }}</div>
                                    <div class="bar">
                                       <div
                                          class="bar-fill bar-blue"
                                          [style.width.%]="r.percent"></div>
                                    </div>
                                    <div class="rev-row-pct">{{ r.percent | number: "1.0-0" }}%</div>
                                 </div>
                              </div>
                           </div>
                           <div class="dist">
                              <div class="dist-title">
                                 <span class="dot dot-teal"></span>
                                 {{ getReviewerLabel(true) }} DISTRIBUTION
                              </div>
                              <div class="rev-rows">
                                 <div
                                    *ngFor="let r of card.reviewerDistribution"
                                    class="rev-row">
                                    <div class="rev-row-label">{{ r.label }}</div>
                                    <div class="bar">
                                       <div
                                          class="bar-fill bar-teal"
                                          [style.width.%]="r.percent"></div>
                                    </div>
                                    <div class="rev-row-pct">{{ r.percent | number: "1.0-0" }}%</div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </ng-container>
               <div
                  *ngIf="!vm?.questionCards?.length"
                  class="no-data">
                  No question insights available. Complete some reviews to see data.
               </div>
            </div>
         </div>

         <div class="right">
            <div class="stack">
               <div class="card all-filters">
                  <div class="card-head">
                     <div class="card-title">Filters</div>
                     <div
                        class="pill"
                        style="margin-top: -20px; cursor: pointer"
                        (click)="toggleFilters()">
                        {{ filtersCollapsed ? "Expand +" : "Collapse -" }}
                     </div>
                  </div>
                  <div
                     *ngIf="!filtersCollapsed"
                     class="all-filters-main">
                     <div class="field">
                        <div class="label">SEARCH {{ getRevieweeLabel(true) }}</div>
                        <input
                           class="form-control"
                           [(ngModel)]="filterSearch"
                           placeholder="e.g., Jeffrey Strom"
                           (keyup.enter)="onSearchEnter()"
                           (input)="onSearchChange($event)" />
                     </div>
                     <div
                        class="field compact"
                        style="align-self: center">
                        <div class="label">&nbsp;</div>
                        <button
                           class="v-button v-button-md v-gray"
                           (click)="clearFilters()"
                           [disabled]="loading">
                           Clear
                        </button>
                     </div>
                  </div>
               </div>

               <div class="card">
                  <div class="card-head">
                     <div class="card-title">Opportunities</div>
                     <div class="pill pill-yesno">Yes/No</div>
                  </div>
                  <div class="chips">
                     <div class="chip">
                        <span>Interested in Lend‑A‑Hand</span>
                        <b>{{ v.lendAHandYes }}</b>
                     </div>
                     <div class="chip">
                        <span>Aspirations to be a Leader</span>
                        <b>{{ v.leaderYes }}</b>
                     </div>
                  </div>
               </div>

               <div class="card">
                  <div class="card-head">
                     <div class="card-title">Medical Interests</div>
                     <div class="pill pill-top">Top Picks</div>
                  </div>
                  <div class="chips">
                     <div
                        class="chip"
                        *ngFor="let t of v.topMedicalInterests">
                        <span>{{ t.label }}</span>
                        <b>{{ t.count }}</b>
                     </div>
                     <div
                        class="muted"
                        *ngIf="!v.topMedicalInterests?.length">
                        No data in selected filters.
                     </div>
                  </div>
               </div>

               <div class="card">
                  <div class="card-head">
                     <div class="card-title">Recently Updated Reviews</div>
                     <div class="pill pill-activity">Activity</div>
                  </div>
                  <table class="tbl">
                     <thead>
                        <tr>
                           <th>{{ getRevieweeLabel(true) }}</th>
                           <th>HOSPITAL</th>
                           <th style="width: 140px">STATUS</th>
                           <th style="text-align: right">UPDATED</th>
                        </tr>
                     </thead>
                     <tbody>
                        <tr *ngFor="let r of v.recentlyUpdated">
                           <td>{{ r.revieweeName }}</td>
                           <td>{{ r.hospital }}</td>
                           <td style="width: 140px">
                              <span
                                 class="status"
                                 [ngClass]="{
                                    'st-complete': r.status === 'Complete',
                                    'st-cos': r.status === getReviewerLabel(true) + ' Submitted',
                                    'st-dvm': r.status === getRevieweeLabel(true) + ' Submitted',
                                    'st-progress': r.status === 'In Progress',
                                 }">
                                 {{ r.status }}
                              </span>
                           </td>
                           <td style="width: 80px; text-align: right">{{ r.updatedOn | date }}</td>
                        </tr>
                     </tbody>
                  </table>
               </div>
            </div>
         </div>
      </div>

      <div
         class="loading"
         *ngIf="loading">
         Loading…
      </div>
      <div
         class="error"
         *ngIf="error">
         {{ error }}
      </div>
   </div>

   <!-- CYCLE MANAGEMENT TAB -->
   <div
      *ngIf="activeTab === 'cycles'"
      class="cycles-tab-shell">
      <app-cycles></app-cycles>
   </div>

   <!-- USER MANAGEMENT TAB -->
   <div *ngIf="activeTab === 'users'">
      <app-user-management
         [allUsers]="allUsers"
         [usersLoading]="usersLoading"
         [currentAdminName]="loggedInUser"
         [pendingUserSelect]="pendingUserSelect"
         [pendingDeferralId]="pendingDeferralId"
         [hospitalOptions]="hospitalOptions"
         [jobCodeOptions]="jobCodeOptions"
         (reloadUsers)="loadAllUsers()"
         (usersChanged)="onUsersChanged($event)"
         (panelClosed)="pendingUserSelect = null"
         (panelOpened)="panelOpened = $event"></app-user-management>
   </div>

   <!-- EXPORT DATA TAB -->
   <div *ngIf="activeTab === 'exports'">
      <!-- Sub-tab nav -->
      <div class="um-sub-tab-nav">
         <div
            class="um-sub-tab-item"
            [class.active]="activeTab === 'exports'"
            (click)="setTab('exports')">
            <i class="fa fa-arrow-up-from-bracket"></i>
            &nbsp; Export Data
         </div>
         <div
            *ngIf="isReportingAdmin()"
            class="um-sub-tab-item"
            style="border-right: 0px"
            (click)="setTab('audit')">
            <i class="fa fa-clock-rotate-left"></i>
            &nbsp; Audit Log
         </div>
      </div>
      <div class="export-big-grid">
         <div
            class="export-big-card"
            (click)="exportExcel('individual')">
            <div class="export-big-icon icon-blue">
               <svg
                  width="22"
                  height="22"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                  <circle
                     cx="12"
                     cy="7"
                     r="4" />
               </svg>
            </div>
            <div class="export-big-title">Individual report</div>
            <div class="export-big-desc">Every question + answer for one user</div>
         </div>
         <div
            class="export-big-card"
            (click)="exportExcel('group')">
            <div class="export-big-icon icon-purple">
               <svg
                  width="22"
                  height="22"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                  <circle
                     cx="9"
                     cy="7"
                     r="4" />
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                  <path d="M16 3.13a4 4 0 0 1 0 7.75" />
               </svg>
            </div>
            <div class="export-big-title">All Q&amp;A by role</div>
            <div class="export-big-desc">Every question + answer, filtered by role group</div>
         </div>
         <div
            class="export-big-card"
            (click)="exportExcel('reviewers')">
            <div class="export-big-icon icon-teal">
               <svg
                  width="22"
                  height="22"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2">
                  <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                  <polyline points="9 22 9 12 15 12 15 22" />
               </svg>
            </div>
            <div class="export-big-title">Reviewer assignments</div>
            <div class="export-big-desc">All reviewees mapped across all review types</div>
         </div>
         <div
            class="export-big-card"
            (click)="exportExcel('aggregate')">
            <div class="export-big-icon icon-orange">
               <svg
                  width="22"
                  height="22"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2">
                  <line
                     x1="18"
                     y1="20"
                     x2="18"
                     y2="10" />
                  <line
                     x1="12"
                     y1="20"
                     x2="12"
                     y2="4" />
                  <line
                     x1="6"
                     y1="20"
                     x2="6"
                     y2="14" />
               </svg>
            </div>
            <div class="export-big-title">Aggregate summary</div>
            <div class="export-big-desc">Rolled-up trends + agreement scores</div>
         </div>
      </div>

      <div class="card admin-card">
         <div
            class="card-head"
            style="margin-bottom: 16px; margin-top: -5px">
            <div class="card-title">Data exports</div>
         </div>

         <div class="export-filter-row">
            <div class="export-filter-group">
               <div class="label">Reviewee Type</div>
               <select
                  class="admin-select"
                  [(ngModel)]="exportReviewType"
                  (change)="onExportReviewTypeChange()">
                  <option value="">All review types</option>
                  <option value="DVM">aDVM</option>
                  <option value="HM">HM</option>
                  <option value="COS">COS</option>
                  <option value="RM">RM</option>
                  <option value="DO">DO</option>
               </select>
            </div>
            <div class="export-filter-group">
               <div class="label">Reviewee</div>
               <select
                  class="admin-select"
                  [(ngModel)]="exportSelectedRevieweeId"
                  [disabled]="!exportReviewType || exportRevieweeOptionsLoading">
                  <option [value]="null">
                     {{ exportRevieweeOptionsLoading ? "Loading..." : "All reviewees" }}
                  </option>
                  <option
                     *ngFor="let u of exportRevieweeOptions"
                     [value]="u.id">
                     {{ u.name }}
                  </option>
               </select>
            </div>
         </div>

         <div class="export-list-row">
            <div>
               <div class="export-row-title">Individual Q&amp;A export</div>
               <div class="export-row-desc">{{ getExportDesc("individual") }}</div>
            </div>
            <span
               *ngIf="exportLoading && clickedExportType == 'individual'"
               class="spinnerSave"
               style="margin-left: auto"></span>
            <button
               class="v-button v-button-md v-teal"
               [disabled]="!exportReviewType || exportRevieweeOptionsLoading || !exportSelectedRevieweeId"
               (click)="exportExcel('individual')">
               Export XLS
            </button>
         </div>
         <div class="export-list-row">
            <div>
               <div class="export-row-title">All Q&amp;A export by role</div>
               <div class="export-row-desc">{{ getExportDesc("group") }}</div>
            </div>
            <span
               *ngIf="exportLoading && clickedExportType == 'group'"
               class="spinnerSave"
               style="margin-left: auto"></span>
            <button
               class="v-button v-button-md v-teal"
               [disabled]="exportLoading"
               (click)="exportExcel('group')">
               Export XLS
            </button>
         </div>
         <div class="export-list-row">
            <div>
               <div class="export-row-title">Reviewer assignment export</div>
               <div class="export-row-desc">{{ getExportDesc("reviewers") }}</div>
            </div>
            <span
               *ngIf="exportLoading && clickedExportType == 'reviewers'"
               class="spinnerSave"
               style="margin-left: auto"></span>
            <button
               class="v-button v-button-md v-teal"
               [disabled]="exportLoading"
               (click)="exportExcel('reviewers')">
               Export XLS
            </button>
         </div>
         <div class="export-list-row">
            <div>
               <div class="export-row-title">Aggregate answer distribution</div>
               <div class="export-row-desc">{{ getExportDesc("aggregate") }}</div>
            </div>
            <span
               *ngIf="exportLoading && clickedExportType == 'aggregate'"
               class="spinnerSave"
               style="margin-left: auto"></span>
            <button
               class="v-button v-button-md v-teal"
               [disabled]="exportLoading"
               (click)="exportExcel('aggregate')">
               Export XLS
            </button>
         </div>
      </div>
   </div>

   <!-- AUDIT LOG TAB -->
   <div *ngIf="activeTab === 'audit'">
      <!-- Sub-tab nav -->
      <div class="um-sub-tab-nav">
         <div
            class="um-sub-tab-item"
            (click)="setTab('exports')">
            <i class="fa fa-arrow-up-from-bracket"></i>
            &nbsp; Export Data
         </div>
         <div
            *ngIf="isReportingAdmin()"
            class="um-sub-tab-item"
            style="border-right: 0px"
            [class.active]="activeTab === 'audit'"
            (click)="setTab('audit')">
            <i class="fa fa-clock-rotate-left"></i>
            &nbsp; Audit Log
         </div>
      </div>
      <div class="card admin-card">
         <div
            class="card-head"
            style="margin-bottom: 16px">
            <div
               class="card-title"
               style="margin-top: -15px">
               Audit Log
            </div>
            <button
               class="v-button v-button-md v-teal"
               (click)="exportExcel('audit')">
               Export log
            </button>
         </div>

         <div
            class="loading"
            *ngIf="auditLoading">
            Loading audit log…
         </div>

         <div
            *ngIf="!auditLoading"
            class="admin-tbl-header-wrap audit-sticky-tabs">
            <table class="audit-tbl">
               <thead>
                  <tr>
                     <th class="audit-tbl-tabs">
                        <div
                           class="audit-links"
                           (click)="onAuditFilter(0)"
                           [class.audit-link-selected]="auditTabs == 0 ? true : false">
                           All Activity
                        </div>
                        <div
                           class="audit-links"
                           (click)="onAuditFilter(1)"
                           [class.audit-link-selected]="auditTabs == 1 ? true : false">
                           Deferrals
                        </div>
                        <div
                           class="audit-links"
                           (click)="onAuditFilter(2)"
                           [class.audit-link-selected]="auditTabs == 2 ? true : false">
                           Cycle Changes
                        </div>
                        <div
                           class="audit-links"
                           (click)="onAuditFilter(3)"
                           [class.audit-link-selected]="auditTabs == 3 ? true : false">
                           Reviewer Changes
                        </div>
                     </th>
                  </tr>
               </thead>
            </table>
         </div>

         <div class="admin-tbl-header-wrap audit-sticky-columns">
            <table
               class="admin-tbl audit-tbl"
               *ngIf="!auditLoading">
               <thead>
                  <tr>
                     <th
                        (click)="setAuditSort('timestamp')"
                        style="cursor: pointer; user-select: none">
                        Timestamp
                        <span *ngIf="sortAuditColumn === 'timestamp'">{{ sortDirection === "asc" ? "↑" : "↓" }}</span>
                     </th>
                     <th
                        (click)="setAuditSort('adminName')"
                        style="cursor: pointer; user-select: none">
                        Admin
                        <span *ngIf="sortAuditColumn === 'adminName'">{{ sortDirection === "asc" ? "↑" : "↓" }}</span>
                     </th>
                     <th
                        (click)="setAuditSort('action')"
                        style="cursor: pointer; user-select: none">
                        Action
                        <span *ngIf="sortAuditColumn === 'action'">{{ sortDirection === "asc" ? "↑" : "↓" }}</span>
                     </th>
                     <th
                        (click)="setAuditSort('rcReasonInput')"
                        style="cursor: pointer; user-select: none">
                        Reason
                        <span *ngIf="sortAuditColumn === 'rcReasonInput'">{{ sortDirection === "asc" ? "↑" : "↓" }}</span>
                     </th>

                     <th
                        (click)="setAuditSort('targetUserName')"
                        style="cursor: pointer; user-select: none">
                        Target user
                        <span *ngIf="sortAuditColumn === 'targetUserName'">{{ sortDirection === "asc" ? "↑" : "↓" }}</span>
                     </th>
                     <th>Details</th>
                  </tr>
               </thead>
            </table>
         </div>

         <table
            class="admin-tbl audit-tbl"
            *ngIf="!auditLoading">
            <tbody>
               <tr *ngFor="let entry of auditLog">
                  <td>{{ formatDate(entry.timestamp) }}</td>
                  <td>{{ entry.adminName }}</td>
                  <td>
                     <span
                        *ngIf="entry.details?.includes('has been deferred')"
                        class="audit-badge"
                        style="display: block; max-width: fit-content; margin-bottom: 6px"
                        [ngClass]="'deferred-reviewee'">
                        Deferred - Open Cycle
                     </span>
                     <span
                        class="audit-badge"
                        *ngIf="!entry.details?.includes('has been deferred')"
                        [ngClass]="{
                           'audit-cycle':
                              entry.action === 'Cycle Changed' ||
                              entry.action === 'Cycle Config Updated' ||
                              entry.action === 'Hospital Cycle Changed',
                           'audit-primary-reviewer': entry.action === 'Primary Reviewer Changed',
                           'audit-reviewer': entry.action === 'Reviewer Changed' || entry.action === 'Hospital Reviewer Changed',
                           'deferred-reviewee': entry.action === 'Reviewee Deferred' || entry.action === 'Reviewee Re-enabled',
                        }">
                        {{ entry.action }}
                     </span>
                  </td>

                  <td>{{ entry.reason ? entry.reason : "---" }}</td>
                  <td>
                     {{
                        entry.action === "Hospital Reviewer Changed" || entry.action === "Hospital Cycle Changed"
                           ? entry.details?.substring(entry.details.lastIndexOf("for ") + 4)?.trim()
                           : entry.targetUserName
                     }}
                  </td>
                  <td>{{ entry.details }}</td>
               </tr>
               <tr *ngIf="auditLog.length === 0">
                  <td
                     colspan="5"
                     class="muted"
                     style="padding: 20px; text-align: center">
                     No audit entries found.
                  </td>
               </tr>
            </tbody>
         </table>
      </div>
   </div>

   <button
      *ngIf="showBackToTop"
      class="back-to-top-button"
      (click)="scrollToTop()"
      aria-label="Back to top">
      <i class="fa fa-chevron-up"></i>
   </button>
</div>

<app-admin-settings
   *ngIf="settingsOpen"
   [initialTab]="settingsTab"
   [messageAttentionCount]="settingsMessageCount"
   (closed)="closeSettings()"
   (attentionCountChange)="onSettingsAttentionCountChange($event)"
   (openMessageContext)="openSettingsMessageContext($event)"></app-admin-settings>
